import React, { useEffect, useState } from "react";
import { Row, Col, Container, Card, CardBody, FormGroup, Label, Input, Button } from "reactstrap";
import MaterialTable from "material-table";

//Services
import { showMessage } from "../../../services/message";
import { api_PUT } from "../../../services/api_service";

//Context
import { useAuth } from "../../../context/auth";

//Constants
import { table_translate } from "../../../constants/MaterialTable";

export default function MotivoExclusaoEquipamentos({ item, handleProximoStep, handleStepAnterior, isUltimaEtapa }) {
    const { setLoading } = useAuth();
    const [equipamentos, setEquipamentos] = useState([]);
    const [motivo, setMotivo] = useState("");

    useEffect(() => {
        if (item && item.requerimentoTransportadorEquipamento) {
            setEquipamentos(item.requerimentoTransportadorEquipamento);
        }
        if (item && item.observacaoRequerente) {
            setMotivo(item.observacaoRequerente);
        }
    }, [item]);

    const handleAvancar = () => {
        if (!motivo || motivo.trim() === "") {
            showMessage("Aviso", "O campo Motivo da Exclusão é obrigatório!", "error", null);
            return;
        }

        setLoading(true);
        let requerimentoUpdate = { ...item };
        requerimentoUpdate.observacaoRequerente = motivo;

        api_PUT("requerimento/PutRequerimento", requerimentoUpdate)
            .then(result => {
                handleProximoStep(result.data);
            })
            .catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
    };

    return (
        <Card className="card-stats">
            <CardBody>
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <h2 className="titulo-solicitacao">Motivo da Exclusão</h2>
                    <div className="formPrincipal">
                        <Row>
                            <Col md="12">
                                <MaterialTable
                                    style={{ minHeight: "auto", marginBottom: "20px" }}
                                    title="Equipamentos Selecionados para Exclusão"
                                    columns={[
                                        { title: 'Número do Equipamento', field: 'numeroEquipamento' },
                                        { title: 'Tipo', field: 'tipo' },
                                        { title: 'Dimensão', field: 'dimensao' },
                                        { title: 'Capacidade', field: 'capacidadeVolume' }
                                    ]}
                                    data={equipamentos}
                                    isLoading={false}
                                    options={{
                                        search: false,
                                        paging: false
                                    }}
                                    localization={table_translate}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Qual o motivo da exclusão?</Label>
                                    <Input
                                        type="textarea"
                                        rows="4"
                                        value={motivo}
                                        onChange={(e) => setMotivo(e.target.value)}
                                        placeholder="Descreva o motivo detalhado para a exclusão dos equipamentos acima."
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col md="6" className="text-left">
                                <Button color="secondary" onClick={() => handleStepAnterior(item)}>
                                    Voltar
                                </Button>
                            </Col>
                            <Col md="6" className="text-right">
                                <Button color={isUltimaEtapa ? "success" : "primary"} onClick={handleAvancar}>
                                    {isUltimaEtapa ? "Finalizar" : "Avançar"}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </CardBody>
        </Card>
    );
}
